import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function KitchenAreas({ children }) {
  useInjectSaga({ key: 'settingsKitchenAreas', saga });
  useInjectReducer({ key: 'settingsKitchenAreas', reducer });

  return React.Children.only(children);
}

KitchenAreas.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withKitchenAreas } from './withKitchenAreas';
export default compose(withConnect, memo)(KitchenAreas);
